<template>
  <div class="space-y-4">
    <div class="font-bold text-xl text-gray-900">
      {{ $t('answers.answers') }}
    </div>
    <AnswersForm
      :question-id="questionId"
      :disabled="!authStore.auth"
      @click="onClick"
      @create="onCreate"
    />
    <template v-for="(answer, idx) in answersList.state.hits" :key="answer.id">
      <AnswersItem
        :answer="answer"
        :is-last="idx === (answersList?.state.hits.length || 0) - 1"
        @delete="onDelete(idx)"
        @edit="(answerData: Answer) => onEdit(idx, answerData)"
      />
    </template>
    <BaseButton
      v-if="
        answersList &&
        !answersList?.allRecordsLoaded &&
        !answersList?.state.processing
      "
      look="link"
      size="none"
      class="w-full font-bold text-sm"
      @click="onShowMore"
      >{{ $t('common.show_more') }}
    </BaseButton>
    <div
      v-if="!answersList || answersList?.state.processing"
      class="py-3 flex justify-center"
    >
      <BaseSpinner />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuth } from '~/stores/auth'
import { useQuestions } from '~/stores/questions'
import type { Answer } from '~/models/questions'

const props = defineProps({
  questionId: {
    type: Number,
    required: true,
  },
})

const emits = defineEmits(['loaded', 'create', 'delete'])

const authStore = useAuth()
const questionsStore = useQuestions()
const answersList = questionsStore.initAnswersList(props.questionId)

async function onShowMore() {
  await answersList.nextPage()
}

function onClick() {
  if (!authStore.auth) {
    authStore.openLoginModal()
  }
}

onMounted(async () => {
  await answersList.getPage()
  emits('loaded')
})

const onDelete = (questionIndex: number) => {
  answersList.state.hits.splice(questionIndex, 1)
  emits('delete')
}

const onCreate = (answerData: Answer) => {
  answersList.state.hits.unshift(answerData)
  emits('create')
}

const onEdit = (questionIndex: number, answerData: Answer) => {
  answersList.state.hits[questionIndex] = answerData
}
</script>
